import { createContext } from 'react';

import type { EmojiProvider } from '@atlaskit/emoji';

type EmojiProviderContextValue = {
	emojiProvider: EmojiProvider | undefined;
};

export const EmojiProviderContext = createContext<EmojiProviderContextValue>({
	emojiProvider: undefined,
});

EmojiProviderContext.displayName = 'EmojiProviderContext';
